export default function quoteReducer(
    state: any = {
        step: 0,
        checkStep: {
            loading: true,
            done: false,
            error: null,
            response: {},
        },
        full: {
            loading: false,
            done: false,
            error: null,
            response: {},
        },
        fullRenewals: {
            loading: false,
            done: false,
            error: null,
            response: {},
        },
        policyType: {
            loading: false,
            done: false,
            error: null,
            policyType: [],
        },
        step00: {
            loading: false,
            done: false,
            error: null,
            response: [],
        },
        step01: {
            loading: false,
            done: false,
            error: null,
            response: [],
        },
        step03: {
            loading: false,
            done: false,
            error: null,
            response: [],
        },
        step04: {
            loading: false,
            done: false,
            error: null,
            response: [],
        },
        step04c: {
            loading: false,
            done: false,
            error: null,
            response: [],
        },
        step05: {
            loading: false,
            done: false,
            error: null,
            response: null,
        },
        step05c: {
            loading: false,
            done: false,
            error: null,
            response: null,
            another_qut: false,
            req_qut: false,
        },
        findAddress: {
            loading: false,
            done: false,
            error: null,
            response: [],
        },
        riskLocations: {
            loading: false,
            done: false,
            error: null,
            response: [],
        },
    },
    action: any) {

    switch (action.type) {

        /**
         *     Get policy type list
         */
        case 'GET_POLICYTYPE_PENDING': {
            return { ...state, policyType: { loading: true } }
        }

        case 'GET_POLICYTYPE_REJECTED': {
            return { ...state, policyType: { loading: false, error: action.payload } }
        }

        case 'GET_POLICYTYPE_FULFILLED': {
            return {
                ...state,
                policyType: {
                    loading: false, done: true, error: null, policyType: action.payload.policyTypes,
                },
            }
        }

        /**
         *     Request new quote creation
         */
        case 'SET_STEP00_PENDING': {
            return { ...state, step00: { loading: true } }
        }

        case 'SET_STEP00_REJECTED': {
            return { ...state, step00: { loading: false, error: action.payload } }
        }

        case 'SET_STEP00_FULFILLED': {
            return {
                ...state,
                step00: {
                    loading: false, done: true, error: null, response: action.payload,
                },
            }
        }

        /**
         *     Send data from Step 01
         */
        case 'SET_STEP01_RENEWAL_PENDING':
        case 'SET_STEP01_PENDING': {
            return { ...state, step01: { loading: true } }
        }

        case 'SET_STEP01_RENEWAL_REJECTED':
        case 'SET_STEP01_REJECTED': {
            return { ...state, step01: { loading: false, error: action.payload } }
        }

        case 'SET_STEP01_RENEWAL_FULFILLED':
        case 'SET_STEP01_FULFILLED': {
            return {
                ...state,
                step01: {
                    loading: false, done: true, error: null, response: action.payload,
                },
            }
        }

        /**
         *     Send data from Step 03
         */
        case 'SET_STEP03_PENDING': {
            return { ...state, step03: { loading: true } }
        }

        case 'SET_STEP03_REJECTED': {
            return { ...state, step03: { loading: false, error: action.payload } }
        }

        case 'SET_STEP03_FULFILLED': {
            return {
                ...state,
                step03: {
                    loading: false, done: true, error: null, response: action.payload,
                },
            }
        }

        /**
         *     Send data from Step 04
         */
        case 'SET_STEP04_PENDING': {
            return { ...state, step04: { loading: true } }
        }

        case 'SET_STEP04_REJECTED': {
            return { ...state, step04: { loading: false, error: action.payload } }
        }

        case 'SET_STEP04_FULFILLED': {
            return {
                ...state,
                step04: {
                    loading: false, done: true, error: null, response: action.payload,
                },
            }
        }

        /**
         *     Send data from Step 04c
         */
        case 'SET_STEP04c_PENDING': {
            return { ...state, step04c: { loading: true } }
        }

        case 'SET_STEP04c_REJECTED': {
            return { ...state, step04c: { loading: false, error: action.payload } }
        }

        case 'SET_STEP04c_FULFILLED': {
            return {
                ...state,
                step04c: {
                    loading: false, done: true, error: null, response: action.payload,
                },
            }
        }

        /**
         *     Send data from Step 05
         */
        case 'BIND_STEP05_QUOTE_VAR_PENDING': {
            return { ...state, step05: { ...state.step05, loading: true } }
        }

        case 'BIND_STEP05_QUOTE_VAR_REJECTED': {
            return { ...state, step05: { ...state.step05, done: true, loading: false, error: action.payload } }
        }

        case 'BIND_STEP05_QUOTE_VAR_FULFILLED': {
            return {
                ...state,
                step05: {
                    loading: false, done: true, error: null, response: action.payload,
                },
            }
        }

        /**
         *     Get existing locations
         */
        case 'GET_LOCATIONS_PENDING': {
            return { ...state, riskLocations: { loading: true } }
        }

        case 'GET_LOCATIONS_REJECTED': {
            return { ...state, riskLocations: { loading: false, error: action.payload } }
        }

        case 'GET_LOCATIONS_FULFILLED': {
            return {
                ...state,
                riskLocations: {
                    loading: false, done: true, error: null, response: action.payload.riskLocations,
                },
            }
        }

        /**
         *     Get full quote details
         */
        case 'GET_FULLQUOTE_PENDING': {
            return { ...state, full: { ...state.full, loading: true } }
        }

        case 'GET_FULLQUOTE_REJECTED': {
            return { ...state, full: { ...state.full, loading: false, error: action.payload } }
        }

        case 'GET_FULLQUOTE_FULFILLED': {
            return {
                ...state,
                full: {
                    ...state.full, loading: false, done: true, error: null, response: action.payload,
                },
            }
        }

        /**
         *     Get full renewals details
         */
        case 'GET_FULLQUOTE_RENEWALS_PENDING': {
            return { ...state, fullRenewals: { ...state.fullRenewals, loading: true } }
        }

        case 'GET_FULLQUOTE_RENEWALS_REJECTED': {
            return { ...state, fullRenewals: { ...state.fullRenewals, loading: false, error: action.payload } }
        }

        case 'GET_FULLQUOTE_RENEWALS_FULFILLED': {
            return {
                ...state,
                fullRenewals: {
                    ...state.fullRenewals, loading: false, done: true, error: null, response: action.payload,
                },
            }
        }

        /**
         *     Check quote step status
         */
        case 'CHECK_QUOTE_STEP_PENDING': {
            return {
                ...state,
                checkStep: { ...state.checkStep, loading: true },
            }
        }

        case 'CHECK_QUOTE_STEP_REJECTED': {
            return {
                ...state,
                checkStep: { ...state.checkStep, loading: false, error: action.payload },
            }
        }

        case 'CHECK_QUOTE_STEP_FULFILLED': {
            return {
                ...state,
                step: action.payload.step,
                checkStep: {
                    loading: false,
                    done: true,
                    error: null,
                    response: action.payload,
                },
            }
        }

        /**
         *  Reset Quotes
         */
        case 'RESET_QUOTES': {
            return {
                ...state,
                checkStep: {
                    loading: true,
                    done: false,
                    error: null,
                    response: {},
                },
                full: {
                    loading: false,
                    done: false,
                    error: null,
                    response: {},
                },
                policyType: {
                    loading: false,
                    done: false,
                    error: null,
                    policyType: [],
                },
                step00: {
                    loading: false,
                    done: false,
                    error: null,
                    response: [],
                },
                step01: {
                    loading: false,
                    done: false,
                    error: null,
                    response: [],
                },
                step03: {
                    loading: false,
                    done: false,
                    error: null,
                    response: [],
                },
                step04: {
                    loading: false,
                    done: false,
                    error: null,
                    response: [],
                },
                step04c: {
                    loading: false,
                    done: false,
                    error: null,
                    response: [],
                },
                step05: {
                    loading: false,
                    done: false,
                    error: null,
                    response: null,
                },
                findAddress: {
                    loading: false,
                    done: false,
                    error: null,
                    response: [],
                },
                riskLocations: {
                    loading: false,
                    done: false,
                    error: null,
                    response: [],
                },
            }
        }

        /**
         *  Reset Steps
         */
        case 'RESET_STEP': {
            return {
                ...state,
                step: 0,
            }
        }
        /**
         *     Default
         */
        default: {
            return { ...state }
        }

    }

}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/reducers/quote.ts